import { TestingControlListRelatedResources } from "api/generated/model";

export function createUserNameLookupFnFromResources(
    relatedResources: TestingControlListRelatedResources
): (userId: number) => string {
    const idToNameMap = new Map<number, string>();
    relatedResources.users.forEach((user) => {
        idToNameMap.set(user.id, `${user.firstname} ${user.lastname}`);
    });
    return (userId: number): string => {
        return idToNameMap.get(userId) || String(userId);
    };
}
